import i18n from '../i18n';
import docTypes from './docTypes';
import {isMobile} from 'react-device-detect';

const IDENTITY_VERIFICATION_PHOTOS_QUALITY = 0.8;
const IDENTITY_VERIFICATION_PHOTOS_MAX_SIZE_MB = 8;

const COUNTRY_CODES = {
  spain: 'ES',
  italy: 'IT',
  portugal: 'PT',
  germany: 'DE',
  uae: 'AE',
  netherlands: 'NL',
  austria: 'AT',
  uk: 'GB',
  france: 'FR',
  belgium: 'BE',
  hungary: 'HU',
  czech: 'CZ',
  colombia: 'CO',
  thailand: 'TH',
  romania: 'RO',
  greece: 'GR',
  slovenia: 'SI',
  croatia: 'HR',
  usa: 'US',
};
export const EU_MEMBERS = [
  'BE',
  'EL',
  'LT',
  'PT',
  'BG',
  'ES',
  'LU',
  'RO',
  'CZ',
  'FR',
  'HU',
  'SI',
  'DK',
  'HR',
  'MT',
  'SK',
  'DE',
  'IT',
  'NL',
  'FI',
  'EE',
  'CY',
  'AT',
  'SE',
  'IE',
  'LV',
  'PL',
];

const GENDERS_OPTIONS = () => [
  {
    value: 'M',
    label: i18n.t('male'),
  },
  {
    value: 'F',
    label: i18n.t('female'),
  },
];
const PATTERNS = {
  dniAndDl: /^[0-9]{8}[a-zA-Z]{1}$/,
  dni: /^[0-9]{8}[a-zA-Z]{1}$/,
  nie: /^[a-zA-Z]{1}[0-9]{7}[a-zA-Z]{1}$/,
  name: /^[A-Za-zÀ-ÖØ-öø-ÿ]*( *[A-Za-zÀ-ÖØ-öø-ÿ *]+)*( *[а-яА-ЯёЁА́-Я́а́-я́*]+)*$/,
  nameWithoutAccents: /^[A-Za-z]*( *[A-Za-z *]+)*( *[а-яА-ЯёЁА *]+)*$/,
  fiscalCode: /^[A-Za-z0-9]+$/,
  email: /^\s*([\w.%+-]+)@([\w-]+\.)?([\w]{2,}\.)?([\w]{2,})\s*$/i,
  docNumber: /^\s*[a-zA-Z0-9\s]*$/,
};
const COUNTRIES_WITH_PURPOSES_OF_STAY = [
  COUNTRY_CODES.romania,
  COUNTRY_CODES.germany,
  COUNTRY_CODES.austria,
];
const CARD_BRANDS = {
  visa: 'V',
};
const TIMEOUT_BEFORE_REDIRECT_MS = 1500;
const COUNTRY_CODES_WITHOUT_SIGNATURE = [COUNTRY_CODES.italy, COUNTRY_CODES.thailand];

const OCR_CHECKING_STATUSES = {
  error: 'ERR',
  complete: 'COM',
  processing: 'PRO',
};

const STAT_TYPES = {
  valtellinaAbit: 'ITVA',
};
const STAT_TYPES_WITH_TAX_EXEMPTIONS = [STAT_TYPES.valtellinaAbit];

const ORIGINS = {
  unknown: 'UNKNOWN',
  checkinOnline: 'CH_ONLINE',
  guestApp: 'GUEST_APP',
  default: 'DEFAULT',
  dashboard: 'DASHBOARD',
  dashboard_pms: 'DASHBOARD_PMS',
  vreasy: 'VREASY',
  octorate: 'OCTORATE',
  lodgify: 'LODGIFY',
  rentals_united: 'RENTALS_UNITED',
  legacy: 'LEGACY',
  booking: 'BOOKING',
  bookingsync: 'BOOKINGSYNC',
  hostaway: 'HOSTAWAY',
  planyo: 'PLANYO',
  mews: 'MEWS',
  guesty: 'GUESTY',
  ofi: 'OFI',
  cloudbeds: 'CLOUDBEDS',
  smoobu: 'SMOOBU',
  apaleo: 'APALEO',
  gomera: 'GOMERA',
  api: 'API',
  dashboard_m: 'DASHBOARD_M',
  ei: 'EI',
  airbnb_calendar: 'AIRBNB_CALENDAR',
  booking_calendar: 'BOOKING_CALENDAR',
  avantio_calendar: 'AVANTIO_CALENDAR',
  generic_calendar: 'GENERIC_CALENDAR',
  cb: 'CB',
  channex: 'CHANNEX',
  resharmonics: 'RESHARMONICS',
  beds24: 'BEDS24',
  sonder: 'SONDER',
  ciaobooking: 'CIAOBOOKING',
  ruralgest: 'RURALGEST',
  easyhotelia: 'EASYHOTELIA',
  casamitger: 'CASAMITGER',
  fnsrooms: 'FNSROOMS',
  komodore: 'KOMODORE',
  lobby_pms: 'LOBBY_PMS',
  mijas_villas: 'MIJAS_VILLAS',
  villas_365: 'VILLAS_365',
  kamooni: 'KAMOONI',
  roomcloud: 'ROOMCLOUD',
  amenitiz: 'AMENITIZ',
  avaibook: 'AVAIBOOK',
  sextaplanta: 'SEXTAPLANTA',
  whoyourguest: 'WHOYOURGUEST',
  wifreezone: 'WIFREEZONE',
  turismoverycheap: 'TURISMOVERYCHEAP',
  vacasa: 'VACASA',
  staymyway: 'STAYMYWAY',
  rentlio: 'RENTLIO',
  ezeetechnosys: 'EZEETECHNOSYS',
  fantasticstay: 'FANTASTICSTAY',
  eviivo: 'EVIIVO',
  masteryield: 'MASTERYIELD',
  bookingautomation: 'BOOKINGAUTOMATION',
  higuests: 'HIGUESTS',
  hoteliga: 'HOTELIGA',
  cosi_group: 'COSI_GROUP',
  myvr: 'MYVR',
  ownerrez: 'OWNERREZ',
  datahotel: 'DATAHOTEL',
  hostify: 'HOSTIFY',
};

const GROUP_TYPES = {
  single: 'S',
  group: 'G',
  family: 'F',
  tourist: 'T',
};

const SINGLE_GROUP_TYPES_OPTIONS = [
  {
    value: GROUP_TYPES.single,
    label: i18n.t('single'),
  },
];
const GROUP_GROUP_TYPES_OPTIONS = [
  {
    value: GROUP_TYPES.group,
    label: i18n.t('group'),
  },
  {
    value: GROUP_TYPES.family,
    label: i18n.t('family'),
  },
];
const ALL_GROUP_TYPES_OPTIONS = [
  ...SINGLE_GROUP_TYPES_OPTIONS,
  ...GROUP_GROUP_TYPES_OPTIONS,
];
const TOURIST_GROUP_GROUP_TYPE_OPTION = {
  value: GROUP_TYPES.tourist,
  label: i18n.t('tourist_group'),
};

const WS_EVENT_TYPES = {
  guestPaymentAccountConfirmed: 'GUEST_PAYMENT_ACCOUNT_CONFIRMED',
  guestPaymentAccountRejected: 'GUEST_PAYMENT_ACCOUNT_REJECTED',
  guestPaymentAccountApiError: 'REMOVE_GUEST_PAYMENT_ACCOUNT_API_ERROR',
  guestPaymentCompleted: 'GUEST_PAYMENT_COMPLETED',
  guestPaymentFailed: 'GUEST_PAYMENT_FAILED',
  securityDepositConfirmed: 'SECURITY_DEPOSIT_CONFIRMED',
  securityDepositCancelled: 'SECURITY_DEPOSIT_CANCELED',
  guestPaymentSecureWaiting: 'GUEST_PAYMENT_SECURE_WAITING',
  securityDepositSecureWaiting: 'SECURITY_DEPOSIT_SECURE_WAITING',
  securityDepositAuthCodeReceived: 'SECURITY_DEPOSIT_AUTH_CODE_RECEIVED',
  guestPaymentAuthCodeReceived: 'GUEST_PAYMENT_AUTH_CODE_RECEIVED',
};

const NONE_EXEMPTION_OPTION = {
  value: 'NONE',
  label: 'none',
};

enum SECURITY_DEPOSIT_STATUSES {
  inactive = 'INACTIVE',
  optional = 'OPTIONAL',
  mandatory = 'MANDATORY',
}

enum RESERVATION_PAYMENT_STATUSES {
  inactive = 'INACTIVE',
  optional = 'OPTIONAL',
  mandatory = 'MANDATORY',
}

const CHANGE_LANGUAGE_TRIGGER_ID = 'language';

const DOC_TYPES_WITH_FRONT_AND_BACK_SIDES_SCAN = [
  docTypes.types.identityCard,
  docTypes.types.dubaiResidencePermit,
];

enum CURRENCIES {
  eur = 'eur',
  usd = 'usd',
  gbp = 'gbp',
  aed = 'aed',
}

const CURRENCIES_SIGNS: Record<CURRENCIES, string> = {
  [CURRENCIES.eur]: '€',
  [CURRENCIES.usd]: '$',
  [CURRENCIES.gbp]: '£',
  [CURRENCIES.aed]: 'د.إ',
};

const CURRENCIES_LABELS: Record<CURRENCIES, string> = {
  [CURRENCIES.eur]: `${CURRENCIES_SIGNS[CURRENCIES.eur]}EUR`,
  [CURRENCIES.usd]: `${CURRENCIES_SIGNS[CURRENCIES.usd]}USD`,
  [CURRENCIES.gbp]: `${CURRENCIES_SIGNS[CURRENCIES.gbp]}GBP`,
  [CURRENCIES.aed]: `${CURRENCIES_SIGNS[CURRENCIES.aed]}AED`,
};

enum PAYMENT_PROVIDERS {
  paycomet = 'PAYCOMET',
  stripe = 'STRIPE',
}

const LINK_COPIED_MESSAGE_TIMEOUT_MS = 1000;

const SHOW_EXPERIENCES_MODAL_TIMEOUT_MS = 3000;

const WHATSAPP_SHARE_LINK = isMobile
  ? 'whatsapp://send/'
  : 'https://api.whatsapp.com/send';
const SMS_SHARE_LINK = 'sms://';
const EMAIL_SHARE_LINK = 'mailto:%20';

const HOURS24 = [
  {
    value: {h: 0, m: 0},
    label: '12:00 am',
  },
  {
    value: {h: 0, m: 30},
    label: '12:30 am',
  },
  {
    value: {h: 1, m: 0},
    label: '1:00 am',
  },
  {
    value: {h: 1, m: 30},
    label: '1:30 am',
  },
  {
    value: {h: 2, m: 0},
    label: '2:00 am',
  },
  {
    value: {h: 2, m: 30},
    label: '2:30 am',
  },
  {
    value: {h: 3, m: 0},
    label: '3:00 am',
  },
  {
    value: {h: 3, m: 30},
    label: '3:30 am',
  },
  {
    value: {h: 4, m: 0},
    label: '4:00 am',
  },
  {
    value: {h: 4, m: 30},
    label: '4:30 am',
  },
  {
    value: {h: 5, m: 0},
    label: '5:00 am',
  },
  {
    value: {h: 5, m: 30},
    label: '5:30 am',
  },
  {
    value: {h: 6, m: 0},
    label: '6:00 am',
  },
  {
    value: {h: 6, m: 30},
    label: '6:30 am',
  },
  {
    value: {h: 7, m: 0},
    label: '7:00 am',
  },
  {
    value: {h: 7, m: 30},
    label: '7:30 am',
  },
  {
    value: {h: 8, m: 0},
    label: '8:00 am',
  },
  {
    value: {h: 8, m: 30},
    label: '8:30 am',
  },
  {
    value: {h: 9, m: 0},
    label: '9:00 am',
  },
  {
    value: {h: 9, m: 30},
    label: '9:30 am',
  },
  {
    value: {h: 10, m: 0},
    label: '10:00 am',
  },
  {
    value: {h: 10, m: 30},
    label: '10:30 am',
  },
  {
    value: {h: 11, m: 0},
    label: '11:00 am',
  },
  {
    value: {h: 11, m: 30},
    label: '11:30 am',
  },
  {
    value: {h: 12, m: 0},
    label: '12:00 pm',
  },
  {
    value: {h: 12, m: 30},
    label: '12:30 pm',
  },
  {
    value: {h: 13, m: 0},
    label: '1:00 pm',
  },
  {
    value: {h: 13, m: 30},
    label: '1:30 pm',
  },
  {
    value: {h: 14, m: 0},
    label: '2:00 pm',
  },
  {
    value: {h: 14, m: 30},
    label: '2:30 pm',
  },
  {
    value: {h: 15, m: 0},
    label: '3:00 pm',
  },
  {
    value: {h: 15, m: 30},
    label: '3:30 pm',
  },
  {
    value: {h: 16, m: 0},
    label: '4:00 pm',
  },
  {
    value: {h: 16, m: 30},
    label: '4:30 pm',
  },
  {
    value: {h: 17, m: 0},
    label: '5:00 pm',
  },
  {
    value: {h: 17, m: 30},
    label: '5:30 pm',
  },
  {
    value: {h: 18, m: 0},
    label: '6:00 pm',
  },
  {
    value: {h: 18, m: 30},
    label: '6:30 pm',
  },
  {
    value: {h: 19, m: 0},
    label: '7:00 pm',
  },
  {
    value: {h: 19, m: 30},
    label: '7:30 pm',
  },
  {
    value: {h: 20, m: 0},
    label: '8:00 pm',
  },
  {
    value: {h: 20, m: 30},
    label: '8:30 pm',
  },
  {
    value: {h: 21, m: 0},
    label: '9:00 pm',
  },
  {
    value: {h: 21, m: 30},
    label: '9:30 pm',
  },
  {
    value: {h: 22, m: 0},
    label: '10:00 pm',
  },
  {
    value: {h: 22, m: 30},
    label: '10:30 pm',
  },
  {
    value: {h: 23, m: 0},
    label: '11:00 pm',
  },
  {
    value: {h: 23, m: 30},
    label: '11:30 pm',
  },
  {
    value: {h: 24, m: 0},
    label: '12:00 pm',
  },
];

enum AGGREGATED_RESERVATION_PAYMENTS_STATUSES {
  paid = 'PAID',
  pending = 'PENDING',
  inactive = 'INACTIVE',
}

enum HOUSING_VERIFICATION_TYPE {
  mandatoryDocumentAndSelfie = 'MANDATORY_DOCUMENT_AND_SELFIE',
  mandatoryDocumentOnly = 'MANDATORY_DOCUMENT_ONLY',
  optionalDocumentAndSelfie = 'OPTIONAL_DOCUMENT_AND_SELFIE',
  optionalDocumentOnly = 'OPTIONAL_DOCUMENT_ONLY',
}

enum RESERVATION_PAYMENT_TYPES {
  upselling = 'UPSELLING',
  touristTaxes = 'TOURIST_TAXES',
  booking = 'BOOKING',
  pmsIntegration = 'PMS_INTEGRATION',
  extraService = 'EXTRA_SERVICE',
  damageProtection = 'DAMAGE_PROTECTION',
  segurityDeposit = 'SECURITY_DEPOSIT',
}

enum GUEST_APP_EVENTS_NAME {
  visited = 'GuestApp - Visited',
  checkIn = 'GuestApp - Chekin',
  upsellings = 'GuestApp - Upsellings',
  dealClicked = 'GuestApp - Deal Clicked',
  dealRequested = 'GuestApp - Deal requested',
  experiencieShowModal = 'GuestApp - Explore Deals Pop-Up',
  experiencieIgnoredModal = 'GuestApp - Ignore Deals Pop-Up',
  paymentRequest = 'Payment Requested',
  paymentCompleted = 'Payment Completed',
  contractDownloaded = 'GuestApp - Contract Downloaded',
  registerAnotherGuest = 'GuestApp - Register Another Guest',
  IDVerificationResult = 'IDVerf - result',
  IDVerificationDocument = 'IDVerf - document',
  IDVerificationSelfie = 'IDVerf - selfie',
  confirmed = 'GuestApp Details confirmed',
  registered = 'GuestApp - Registered',
}

enum STORAGE_KEYS {
  personalFormData = 'PERSONAL_FORM_DATA',
  personalSignatureFormData = 'PERSONAL_SIGNATURE_FORM_DATA',
}

const EXEMPTIONS_IDS = {
  under14: 'UNDER14',
  under18: 'UNDER18',
  tec: 'TEC',
  ea: 'EA',
  mr: 'MR',
};

enum ERROR_MODAL_ORIGIN  {
  stripe = 'STRIPE'
};

export {
  IDENTITY_VERIFICATION_PHOTOS_QUALITY,
  IDENTITY_VERIFICATION_PHOTOS_MAX_SIZE_MB,
  RESERVATION_PAYMENT_TYPES,
  AGGREGATED_RESERVATION_PAYMENTS_STATUSES,
  HOUSING_VERIFICATION_TYPE,
  CURRENCIES_SIGNS,
  CURRENCIES_LABELS,
  CURRENCIES,
  PAYMENT_PROVIDERS,
  NONE_EXEMPTION_OPTION,
  WS_EVENT_TYPES,
  ORIGINS,
  COUNTRY_CODES_WITHOUT_SIGNATURE,
  COUNTRY_CODES,
  GENDERS_OPTIONS,
  PATTERNS,
  COUNTRIES_WITH_PURPOSES_OF_STAY,
  CARD_BRANDS,
  TIMEOUT_BEFORE_REDIRECT_MS,
  OCR_CHECKING_STATUSES,
  STAT_TYPES,
  STAT_TYPES_WITH_TAX_EXEMPTIONS,
  GROUP_TYPES,
  SECURITY_DEPOSIT_STATUSES,
  RESERVATION_PAYMENT_STATUSES,
  CHANGE_LANGUAGE_TRIGGER_ID,
  DOC_TYPES_WITH_FRONT_AND_BACK_SIDES_SCAN,
  SINGLE_GROUP_TYPES_OPTIONS,
  GROUP_GROUP_TYPES_OPTIONS,
  ALL_GROUP_TYPES_OPTIONS,
  TOURIST_GROUP_GROUP_TYPE_OPTION,
  LINK_COPIED_MESSAGE_TIMEOUT_MS,
  SHOW_EXPERIENCES_MODAL_TIMEOUT_MS,
  WHATSAPP_SHARE_LINK,
  SMS_SHARE_LINK,
  EMAIL_SHARE_LINK,
  HOURS24,
  GUEST_APP_EVENTS_NAME,
  STORAGE_KEYS,
  EXEMPTIONS_IDS,
  ERROR_MODAL_ORIGIN
};
